import styled from 'styled-components'

export const Input = styled.input`
    padding: 15px 15px 15px 15px;
    border-radius: 25px;
    cursor: pointer;
`